import { render } from "./CreateWorkflow.vue?vue&type=template&id=53c9d676&ts=true"
import script from "./CreateWorkflow.vue?vue&type=script&lang=ts"
export * from "./CreateWorkflow.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__